import React from 'react';
import { motion } from 'framer-motion';
import { AlertHistory } from '../../../types/solarMonitoring';

interface AlertHistoryTabProps {
  alertHistory: AlertHistory[];
}

export const AlertHistoryTab: React.FC<AlertHistoryTabProps> = ({ alertHistory }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <h2 className="text-xl font-semibold text-gray-900">Alert History</h2>
      
      <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Rule
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Triggered At
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Power Output
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Efficiency
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Recipients
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {alertHistory.map((alert) => (
                <tr key={alert.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">
                      {alert.rule?.name || 'Unknown Rule'}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {new Date(alert.triggeredAt).toLocaleString()}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {alert.powerData.directionPvValue.toFixed(2)} kW
                    </div>
                    <div className="text-sm text-gray-500">
                      / {alert.powerData.ratedPower} kW
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {alert.powerData.percentageOutput.toFixed(1)}%
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {alert.emailsSent.length} recipient(s)
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          {alertHistory.length === 0 && (
            <div className="p-8 text-center text-gray-500">
              No alerts have been triggered yet.
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};